/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import ModalVideo from 'react-modal-video';
import axios from 'axios';
import { styled } from '@mui/system';
import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/components/KnowledgeCentre/KnowledgeCentre.scss';
import VideoView from '../../knowledgeCentre/components/VideoView';
// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useMoengage from '../../../hooks/useMoengage';
import { VIEW_TYPES, ANALYTICS_EVENTS, SHARE_OPTIONS, CONTENT_SECTIONS } from '../../../constants/MitraContentConstants';
import DialolPopup from '../../knowledgeCentre/components/DialogPopup';

const MODE = SHARE_OPTIONS.WHATSAPP;

const Styleddiv = styled('div')({
  marginTop: '50px',
  width: '100%',
});

function MitraShots() {
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [currentVideoId, setCurrentVideoId] = useState('rZsYkVsf1fU');
  const [userId, setUserId] = useState('');
  const [createMoengageUser, trackEvent, triggerContentInteractedEvent] = useMoengage();
  const [share, setShare] = React.useState(false);
  const [currentLink, setCurrentLink] = React.useState('link not available');
  const [error, setError] = useState(false);
  const [likedItems, setLikedItems] = useState([]);
  const [videoArray, setVideoArray] = useState([]);

  const getUpdatedSelectedLikeButton = id => {
    const items = likedItems.slice();
    const index = likedItems.indexOf(id);
    if (index >= 0) {
      items.splice(index, 1);
      setLikedItems(items);
    } else {
      items.push(id);
      setLikedItems(items);
    }
  };

  let sliderImageClasses = ['view', 'slider_image1'];
  sliderImageClasses = sliderImageClasses.join(' ');

  const handleClickOpen = view => {
    setCurrentVideoId(view.videoUUID);
    setOpen(true);
    triggerContentInteractedEvent(ANALYTICS_EVENTS.MITRA_BONUS_VIDEO_PLAYED, {
      content_url:view.url,
      container_position: view.containerPosition,
    });
  };

  const handleClickShare = (view, type) => {
    setShare(true);
    if (type === VIEW_TYPES.VIDEO) {
      setCurrentLink(view.url);
      triggerContentInteractedEvent(ANALYTICS_EVENTS.MITRA_BONUS_VIDEO_LINK_SHARED, {
        content_url:view.url,
        container_position: view.containerPosition,
        mode: MODE,
      });
    }
  };

  const handleClickLike = view => {
    console.log('handleClickLike', view);
    triggerContentInteractedEvent(ANALYTICS_EVENTS.VIDEO_LINK_LIKED, {
      content_url:view.url,
      container_position: view.containerPosition,
      mode: MODE,
    });
  };

  const handleCloseShare = () => {
    setShare(false);
  };

  const fetchMitraBonusVideos = () => {
    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_API_HOST}/v2/app/mitraBonusVideos`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': '*',
        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
        'Access-Control-Allow-Headers':
          'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
        'Cache-Control': null,
        'X-Requested-With': null,
      },
    };

    return axios(config).then(response => {
      if (response.status === 200) {
        const res = response.data;
        const arr = res.mitraBonus.map(obj => {
          return {
            ...obj,
            url: obj.landingUrl,
            id: obj.id,
            videoUUID: obj.landingUrl.split('=')[1],
            containerPosition: obj.rank,
          };
        });
        setVideoArray(arr);
      } else {
        throw new Error('Server Error');
      }
    });
  };

  useEffect(() => {
    const paramString = window.location.href.split('?')[1];
    const queryString = new URLSearchParams(paramString);
    let userIdParam;
    queryString.forEach((value, key) => {
      if (key === 'userId') userIdParam = value;
    });
    fetchMitraBonusVideos();
    if (!userIdParam) {
      setError('Service unavailable');
    } else {
      async function fetchUserInfo(endPoint, query) {
        const config = {
          method: 'get',
          url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
            'Access-Control-Allow-Headers':
              'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            'Cache-Control': null,
            'X-Requested-With': null,
          },
        };

        return axios(config).then(response => {
          if (response.status === 200) {
            return response.data;
          }
          throw new Error('Server Error');
        });
      }
      fetchUserInfo('user_details', `userId=${userIdParam}`)
        .then(userData => {
          createMoengageUser(userIdParam, userData.name, userData.phoneNumber);
        })
        .catch(e => {
          setError(e.toString());
          // setIsLoading(false);
          // setTimeout(() => Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userIdParam}`}), 5000);
        });
      setIsLoading(false);
      setUserId(userIdParam);
    }
  }, []);

  return isLoading ? (
    <AnimatedLoader />
  ) : (
    <div className="my_knowledge_centre">
      <div className="knowledge_centre_container">
        <p
          style={{
            paddingInlineStart: '3%',
            paddingTop: '10%',
            marginLeft: '-10px',
            width: '100%',
            height: '30px',
            fontFamilyReactPlayer: 'Open Sans',
            fontSize: '20px',
            lineHeight: '150%',
            verticalAlign: 'Top',
            alignContent: 'Left',
          }}
        >
          <b>Mitra Bonus Videos</b>
        </p>

        {videoArray.map((view, index) => (
          <Styleddiv key={view.id}>
            <VideoView
              hideDescription
              sliderImageClasses={sliderImageClasses}
              video={view}
              handleClickOpen={handleClickOpen}
              handleClickLike={handleClickLike}
              likedItems={likedItems}
              getUpdatedSelectedLikeButton={getUpdatedSelectedLikeButton}
              handleClickShare={handleClickShare}
              contentSection={CONTENT_SECTIONS.MITRA_BONUS}
            />{' '}
          </Styleddiv>
        ))}

        <>
          <ModalVideo
            channel="youtube"
            youtube={{
              autoplay: 1,
            }}
            isOpen={open}
            videoId={currentVideoId}
            theme="dark"
            onClose={() => setOpen(false)}
          />
        </>

        <DialolPopup shareUrl={currentLink} open={share} onClose={handleCloseShare} />
      </div>
    </div>
  );
}

export default MitraShots;
